import {NgModule} from '@angular/core';
import {GateweeCheckboxComponent} from './gatewee-checkbox.component';

/** Re-exports standalone checkbox for NgModule consumers (ComponentsV2Module, gatewee-filter). */
@NgModule({
  imports: [GateweeCheckboxComponent],
  exports: [GateweeCheckboxComponent],
})
export class GateweeCheckboxModule {}
